module.exports = __webpack_public_path__ + "img/位图.b5aae185.png";